import { useEffect } from "react";
import content from "../data/content.json";
import { useCmsDoc } from "../hooks/useCmsDoc";
import { COLOR_FIELDS, mergeIdentity } from "../lib/identityAgdysa";

function upsertFontLink(id, href) {
  if (!href) return;
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("link");
    el.id = id;
    el.rel = "stylesheet";
    document.head.appendChild(el);
  }
  if (el.getAttribute("href") !== href) el.setAttribute("href", href);
}

/** Aplica colores y tipografía publicados en site/identity sobre :root. */
export default function IdentityTheme() {
  const { data } = useCmsDoc("site", "identity", null);

  useEffect(() => {
    const identity = mergeIdentity(data, content.logos);
    const root = document.documentElement;
    for (const field of COLOR_FIELDS) {
      const hex = identity.colores[field.key]?.hex;
      if (hex) root.style.setProperty(field.cssVar, hex);
    }
    root.style.setProperty("--font-display", `"${identity.tipografia.principal.family}", sans-serif`);
    root.style.setProperty("--font-body", `"${identity.tipografia.secundaria.family}", sans-serif`);
    upsertFontLink("agdysa-font-display", identity.tipografia.principal.googleFontsUrl);
    upsertFontLink("agdysa-font-body", identity.tipografia.secundaria.googleFontsUrl);
  }, [data]);

  return null;
}
